/** Returns the title of the document page */
export function getDocPageTitle(docName?: string) {
    return docName ? `${docName} (document)` : 'Documents';
}
